import type { ITableLikeTreeItem } from 'components/TableLikeTree/context';
import { getInsertAfterObjectId } from 'components/TableLikeTree/utils';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimMoveContractObjectGql } from '../BimContractStructureRequests';

const requestId = 'bimMoveContractObject';

export const useBimMoveContractObject = () => {
    const dispatch = useDispatch();
    const [bimMoveContractObjectReset] = useResetStoreData({ requestId });

    const [, , , bimMoveContractObjectMakeRequest] = useRequest({
        requestId,
        query: bimMoveContractObjectGql,
        withEffect: false,
    });

    useEffect(() => {
        bimMoveContractObjectReset(undefined);
    }, [bimMoveContractObjectReset]);

    return useCallback(
        (
            source: ITableLikeTreeItem,
            target: ITableLikeTreeItem,
            onExternalProcessSuccess: (
                source: ITableLikeTreeItem,
                target: ITableLikeTreeItem,
                isInsert?: boolean,
                isBefore?: boolean,
            ) => any,
            rows: ITableLikeTreeItem[],
            isInsert?: boolean,
            isBefore?: boolean,
        ) => {
            bimMoveContractObjectReset(undefined);

            dispatch(
                bimMoveContractObjectMakeRequest(
                    {
                        contractObjectId: source.id,
                        insertAfterObjectId: getInsertAfterObjectId(rows, source, target, isInsert, isBefore),
                        newParentObjectId: isInsert ? target.parent?.id : target.id,
                    },
                    () => onExternalProcessSuccess(source, target, isInsert, isBefore),
                ),
            );
        },
        [bimMoveContractObjectMakeRequest, bimMoveContractObjectReset, dispatch],
    );
};
